'use client';

import PendingCookies from '~/contracts/common/PendingCookies';
import useSetPendingCookies from '~/hooks/common/ui/useSetPendingCookies';

type OwnProps = {
  cookies: PendingCookies;
  generatedAt: number;
  location: string;
};

export default function PendingCookiesClient({
  cookies = [],
  generatedAt,
  location
}: OwnProps) {
  useSetPendingCookies(cookies, generatedAt, location);

  return null;
}
